import cs from 'classnames';
import React from 'react';

import defaultImage from '@/assets/images/default_image.png';

type Props = {
  src: string;
  alt: string;
  className?: string;
  hideOnError?: boolean;
  base64?: boolean;
  ratio?: 'auto' | 'square' | '3/4' | '4/3' | '16/9' | '9/16';
  rounded?: 'none' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl' | 'full';
  height?: number | string;
  draggable?: boolean;
  width?: number | string;
};

export const Image = ({ src, alt, className = '', draggable, ratio = 'auto', rounded = 'none', hideOnError, base64, height, width }: Props) => {
  return (
    <img
      src={src}
      draggable={draggable}
      alt={alt}
      height={height}
      width={width}
      className={cs(`${className} object-cover rounded-${rounded} aspect-${ratio}`)}
      onError={(e: React.SyntheticEvent<HTMLImageElement, Event>) => {
        if (!base64) {
          e.currentTarget.src = defaultImage;
        }

        if (hideOnError) {
          e.currentTarget.style.display = 'none';
        }
      }}
    />
  );
};
